import styled from "styled-components";
import { FontStyles } from "../../../components";

const Container = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    flex: 1,
  };
});
const ImageIcon = styled.img(({ theme, $AMCRED }) => {
  const { spacing } = theme;
  return {
    height: spacing(2.625),
    marginRight: spacing(0.625),
    filter:
      "invert(18%) sepia(0%) saturate(0%) hue-rotate(222deg) brightness(99%) contrast(86%)",
  };
});
const Content = styled.div(({ theme }) => {
  const { palette: colors } = theme;
  return {
    ...FontStyles.bold16,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    textTransform: "uppercase",
    color: colors.text.primary,
  };
});

const Style = {
  Container,
  Content,
  ImageIcon,
};

export default Style;
